









































































































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { CHIP_COLORS } from '@/constants/ux-constants'
import { MATERIAL_TYPES } from '@/constants/schema-constants'
import { Material, User } from '@/dtos/commons'
import { Reaction } from '@/dtos/static-assets/get'
import { CurrentAdminManager } from '@/mixins/current-admin-manager'
import { staticAssetsModule } from '@/stores/static-assets-store'

@Component({
  components: {
    SmBadgeRead: () => import('@/components/atoms/SmBadgeRead.vue'),
    SmChip: () => import('@/components/atoms/SmChip.vue'),
    SmText: () => import('@/components/atoms/SmText.vue'),

    SmMaterialDisplay: () => import('@/components/molecules/SmMaterialDisplay.vue'),
    SmListUser: () => import('@/components/molecules/list/SmListUser.vue'),
  }
})
export default class SmCardConsultationSummary extends Mixins(CurrentAdminManager) {
  private CHIP_COLORS = Object.freeze(CHIP_COLORS)
  private MATERIAL_TYPES = Object.freeze(MATERIAL_TYPES)

  @Prop({ required: true })
  private isUnread!: boolean

  @Prop({ required: false })
  private isSystemAdminMessage!: boolean

  @Prop({ required: true })
  private hasDraft!: boolean

  @Prop({ required: true })
  private ownerUser!: User

  @Prop()
  private message?: string

  @Prop()
  private material?: Material

  @Prop()
  private postedAt?: string

  @Prop({ default: () => [] })
  private reactions!: string[]

  @Prop()
  private admin?: User

  private get reactionsMaster(): Reaction[] { return staticAssetsModule.reactions }
}
